module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYCAYAAAARfGZ1AAAABHNCSVQICAgIfAhkiAAAAQxJREFUSInVlTFuwkAURJ8jinQgcYIoEW3SUmU76HIE6HMJcoJcgdyCVOYITmvBESwFkZIwKVgTeTHW/kggMo1Xq9nZ8dffP3BCJLFESRO/fGygvSRJMjc5kOQUCZOwF08lfUXql3/IleGOa6spi7gZrb8cms5yPpYFAKNBj4e7bi3v8pyPh70o3nmdS3KAo/pYOiEvW+xqfqzeB+JeOA04K6ANbMuN6Szn7T0H4PW5f/SC0Lmr4bT9dz8qxsPfDol2bkGTaInzt2K2KPY1vb/tHrTeRTyiCiRNGqbd9pRT0QyLeHRqVcS1S5qU5ggD2ERoPvlwcXXdkgE3QBlZa+Ab+Az2Q6yBwvP+OX4AXKbmNNJ3LlwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/1_active.png
// module id = Ny7V
// module chunks = 171